// extracted by mini-css-extract-plugin
export var localeSelector = "_be-0";